import urlParse from 'url-parse';
export const parseUrl = (str) => {
    return urlParse(str, true);
};
//# sourceMappingURL=urls.js.map